import locales from './locales';

const getRoleLabel = ({
  isDirector,
  isMajorShareholder,
  percentOfShares,
}: {
  isDirector: boolean | null;
  isMajorShareholder: boolean | null;
  percentOfShares: number | null;
}) => {
  if (isDirector) {
    if (percentOfShares) {
      return locales.formatString(locales.bothRoleWithAmount, {
        percentOfShares: Math.round(percentOfShares),
      });
    }

    if (isMajorShareholder) {
      return locales.bothRole;
    }

    return locales.directorRole;
  }

  if (percentOfShares) {
    return locales.formatString(locales.shareholderRoleWithAmount, {
      percentOfShares: Math.round(percentOfShares),
    });
  }

  if (isMajorShareholder) {
    return locales.majorShareholderRole;
  }

  return null;
};

export default getRoleLabel;
